module.exports = __webpack_public_path__ + "img/DE00858.0bddc69b.png";